<template>
    <v-dialog v-model="dialog" max-width="430" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11">
            <h2 class="text-center">{{$t('global.are_you_sure')}}</h2>
            <p class="text-center font-weight-bold mt-3">{{$t('homework.delete')}}</p>
            <v-card-actions class="d-flex justify-center">
                <v-btn class="green white--text mr-4" type="submit" :loading="loadingRequest" @click="deleteHomework">{{$t('global.yes')}}</v-btn>
                <v-btn class="transparent green--text ml-4" @click="dialog = false">{{$t('global.no')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['homework_id'],
        data(){
            return {
                dialog: false,
                loadingRequest: false,
            }
        },
        methods: {
            deleteHomework() {
                this.loadingRequest = true;
                this.$api('homework').delete(this.homework_id)
                    .then(() => {
                        this.$parent.$emit('getData');
                        this.$store.dispatch('alert', {type: 1, message: this.$t('global.success_deleted')});
                    }).finally(() => {
                    this.loadingRequest = false;
                    this.dialog = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/components/dialog";
</style>